import {
  ApplicationInitResult,
  RemoteApplicationStarter,
} from './types';

export const startRemoteApplication: RemoteApplicationStarter = (url, path, data): ApplicationInitResult => {
  throw new Error('not implemented');
};
